import React, { useEffect, useRef } from "react";
import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";
import useGeoJsonReader from "./hooks/useGeoJsonReader";

const Map = ({ geoJson }) => {
  const { getPolygon, centerPolygon } = useGeoJsonReader();
  const geoJsonRef = useRef();

  let polygon = getPolygon(geoJson);
  let position = centerPolygon(polygon);

  useEffect(() => {
    if (geoJsonRef.current) {
      geoJsonRef.current.clearLayers();
      geoJsonRef.current.addData(geoJson);
    }
  }, [geoJsonRef, geoJson]);

  function UpdateCenter() {
    const map = useMap();
    map.setView(position);
  }

  const containerStyle = {
    width: "50vw",
    height: "80vh",
    marginRight: "5em",
    marginTop: "4em",
  };

  return (
    <>
      <MapContainer
        style={containerStyle}
        center={position}
        zoom={5}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <GeoJSON ref={geoJsonRef} key={position} data={geoJson} />

        <UpdateCenter />
      </MapContainer>
    </>
  );
};

export default Map;
